import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";

const PaymentList = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatDate = (unixTimestamp) => {
    if (!unixTimestamp) return "-";
    const d = new Date(unixTimestamp * 1000);
    return d.toLocaleString();
  };

  const getUserLabel = (order) => {
    if (order.name && order.surname) return `${order.name} ${order.surname}`;
    if (order.company) return order.company;
    return "Anonimo";
  };

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const token = localStorage.getItem("jwt_token");

        const host = import.meta.env.VITE_HOST;
        const port = import.meta.env.VITE_PORT;

        const res = await fetch(`${host}:${port}/api/v1/orders/get_all_orders`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const data = await res.json();

        if (res.ok && data.status === "OK") {
          setPayments(data.data);
          setLoading(false);
        } else {
          throw new Error(data.message || "Errore nel recupero dei pagamenti");
        }
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPayments();
  }, []);

  if (loading)
    return (
      <div className="flex justify-center items-center h-64 text-gray-600">
        Caricamento pagamenti...
      </div>
    );

  if (error)
    return (
      <div className="text-red-600 text-center mt-10 font-semibold">
        Errore: {error}
      </div>
    );

  return (
    <div className="flex min-h-screen bg-white">
      <AdminSidebar className="bg-white shadow-md p-5 w-64" />

      <main className="flex-1 p-8">
        <h2 className="text-xl font-semibold mb-6" style={{ color: "#94c41c" }}>
          Lista Pagamenti Effettuati
        </h2>

        {payments.length === 0 ? (
          <p className="text-gray-600">Nessun pagamento trovato.</p>
        ) : (
          <div className="overflow-x-auto rounded-lg border border-gray-300 shadow bg-white">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    ID Ordine
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Acquirente
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Dominio
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Importo ($)
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Data Ordine
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Stato Pagamento
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Metodo di Pagamento
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {payments.map((order) => (
                  <tr key={order.id_order}>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{order.id_order}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{getUserLabel(order)}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-green-600 font-semibold">
                      {order.domain || order.domain_name || "-"}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      ${parseFloat(order.amount).toFixed(2)}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{formatDate(order.order_date)}</td>
                    <td
                      className={`px-4 py-3 whitespace-nowrap text-sm font-semibold ${
                        order.status === "succeeded"
                          ? "text-green-600"
                          : order.status === "pending"
                          ? "text-yellow-600"
                          : "text-red-600"
                      }`}
                    >
                      {order.status === "succeeded"
                        ? "Completato"
                        : order.status === "pending"
                        ? "In attesa"
                        : "Fallito"}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      {order.payment_method || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
};

export default PaymentList;
